export * from "./downloadFile";
export * from "./product";
export * from "./header";

export const makeid = length => {
  let result = "";
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
};

export const COMMENT_TYPE = {
  COMMENTS: 'comments',
  FEEDBACKS: 'feedbacks'
};

/**
 * Formats a price (in грн) for display. Free items (samplers/gifts) now cost
 * 0.01 грн (1 копійка) instead of 0, so kopecks must be preserved for
 * non-whole values; whole amounts stay without decimals as before.
 * @param {number} value
 * @returns {string}
 */
export const formatPrice = value => {
  const number = Number(value) || 0;
  return Number.isInteger(number) ? String(number) : number.toFixed(2);
};

export const countComments = (comments, type) => {
  return comments.reduce((acc, item) => {
    let child = type === COMMENT_TYPE.COMMENTS ? item.comments : item.child;
    let childArray = child.data && child.data.length ? child.data : [];
    let childCounter = childArray.length ? countComments(childArray, type) : 0;
    return acc + 1 + childCounter;
  }, 0);
};
